import React from "react";
import checkmark from "../image/checkmark.png";

const Project = ({data}) => {


  return (
    <div>
      <li className={`flex flex-col items-start justify-center  mx-4 mb-3 sm:w-3/5 ${data.float?'float-right':''}`}>
        {data.video && !data.youtube && <video src={`${process.env.PUBLIC_URL}/${data.media_url}`} controls muted></video>}
        {data.youtube && <iframe className="w-full h-72 sm:h-96 " src={data.youtube_url} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>}
        {!data.video && <img src={`${process.env.PUBLIC_URL}/${data.media_url}`} alt=''  />}
        <h1 className="text-3xl py-3">{data.project_name}</h1>
        <p className=" text-zinc-700 leading-relaxed">{data.description}</p>
        <a
          className="block mx-auto border  hover:bg-slate-200 shadow-lg transition-all border-gray-700 px-3 py-1 rounded"
          href="https://github.com/ar889/chatties"
          target={"_blank"}
          rel="noreferrer"
        >
          Github Repo <img className="inline " src={data.repo} alt="" />
        </a>
        {data.deployed && <a
          className="block mx-auto border hover:bg-slate-200 shadow-lg transition-all border-gray-700 px-3 py-1 rounded mt-2"
          href={data.web_link}
          target={"_blank"}
          rel="noreferrer"
        >
          View Demo <img className="inline " src={data.repo} alt="" />
        </a>}
        <ul className=" my-1">
           {data.technologies.map(tech=>(
         <li>
         <img
           className="inline-block w-6"
           src={checkmark}
           alt="tick_mark"
         />
         {tech}
       </li>
     ))} 
        </ul>
      </li>
    </div>
  );
};

export default Project;
